import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

export const isUserAdmin = async (userId) => {
  const adminDoc = await getDoc(doc(db, "admins", userId));
  return adminDoc.exists();
};
